const PRICE_TICK = 0.01

/**
 * Agrupa limites abertas no mesmo preço e lado numa linha só.
 * Cada grupo guarda os orderId para uma linha com uma ordem só poder ser editada.
 * @param {Array<{orderId?: string, side?: string, price?: number, remainQty?: number, origQty?: number}>} orders
 */
export function clusterOpenLimits(orders) {
  const map = new Map()

  for (const order of orders || []) {
    const price = Number(order?.price)
    if (!Number.isFinite(price) || price <= 0) continue

    const side = String(order.side || '').toUpperCase() === 'SELL' ? 'SELL' : 'BUY'
    const qty = Number(order.remainQty ?? order.origQty)
    const orderId = order?.orderId != null && order.orderId !== '' ? String(order.orderId) : null
    const key = `${side}|${price}`
    const existing = map.get(key)

    if (!existing) {
      map.set(key, {
        key,
        side,
        price,
        qty: Number.isFinite(qty) ? qty : 0,
        count: 1,
        orderIds: orderId ? [orderId] : [],
      })
      continue
    }

    existing.qty += Number.isFinite(qty) ? qty : 0
    existing.count += 1
    if (orderId) existing.orderIds.push(orderId)
  }

  return [...map.values()].sort((a, b) => a.price - b.price || a.side.localeCompare(b.side))
}

export function roundLimitPrice(price) {
  const n = Number(price)
  if (!Number.isFinite(n) || n <= 0) return null
  const ticks = Math.round(n / PRICE_TICK)
  return Number((ticks * PRICE_TICK).toFixed(2))
}

export function parseLimitQty(value) {
  const n = Number(String(value ?? '').trim().replace(',', '.'))
  if (!Number.isFinite(n) || n <= 0) return null
  return n
}
